import { cardDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { CardMethod } from "@/modules/billing/paymentMethods.ts";
import type { PaypalVaultConfig } from "@warrenio/api-spec/spec.oats.gen";
import React from "react";

/* eslint-disable react-refresh/only-export-components */

const PaypalVaultAddForm = React.lazy(() => import("@/modules/billing/paypal/PaypalVaultAddForm.tsx"));
const PaypalVaultPaymentForm = React.lazy(() => import("@/modules/billing/paypal/PaypalVaultPaymentForm.tsx"));

export function makePaypalVault(config: PaypalVaultConfig): CardMethod {
    return {
        ...cardDefaults(config),
        PaymentForm: (props) => <PaypalVaultPaymentForm {...props} config={config} />,
        AddForm: (props) => <PaypalVaultAddForm {...props} config={config} />,
    };
}
